import { createContext } from "react";

export interface FeatureAppConfig {
  globalApi: string;
};

export const AppContext = createContext<FeatureAppConfig>({
  globalApi: "https://globalapi.vwtools.ca"
});
